import { WS_ENDPOINTS } from "./constants";
const socketInstances: Record<string, WebSocket> = {};

export const getWebSocket = (endpoint: keyof typeof WS_ENDPOINTS, ...pathParams: (string | number)[]) => {
  let url = `${process.env.REACT_APP_SW_HOST}/ws/${WS_ENDPOINTS[endpoint]}`;
  if (pathParams.length) {
    url += "/" + pathParams.map(encodeURIComponent).join("/");
  }
  url += "/"; // trailing slash

  if (!socketInstances[endpoint] || socketInstances[endpoint].readyState === WebSocket.CLOSED) {
    socketInstances[endpoint] = new WebSocket(url);
  }

  return socketInstances[endpoint];
};
